const ContactMe = {

	init() {
		this.el = $('[component="ContactMe"]');
		if (!this.el.length) return;

		this.select = this.el.find('.select');
		this.options = this.select.find('.option');
		this.input = this.el.find('input[name="contact"]');
		this.typeInput = this.el.find('input[name="type"]');
		this.button = this.el.find('button');
		this.bind();
	},

	bind() {
		this.select.click((evt) => {
			const el = $(evt.currentTarget);
			if (el.is('.active')) el.removeClass('active');
			else el.addClass('active');
		});

		this.options.click((evt) => {
			const el = $(evt.currentTarget);
			const selected = this.select.find('.selected b');
			selected.text(el.data('value'));
			selected.attr('icon', el.attr('icon'));

			this.input.attr('placeholder', el.data('text'));
			this.input.attr('type', el.data('type'));
			this.typeInput.val(el.data('contact'));
		});
	},

	afterSubmit() {
		console.log('afterSubmit');
	},
};

export default ContactMe;